

































































































































































































import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';
import { Indicador } from '@/plugins/api';
import EditarBanco from './EditarBanco.vue';
import env from '@/env';

@Component({
  components: {
    EditarBanco,
  },
})
export default class CardIndicador extends Vue {
  @PropSync('codigo', { type: Number }) public readonly indicadorId!: number;
  @Prop() public readonly data!: IIndicador;
  public indicador = {} as IIndicador;

  public loadingIndicador = true;
  public loadingValidacao = false;
  public loadingBanco = true;

  public popoverRejeitar = false;
  public motivoRejeicao = '';
  public processing = false;

  public galleryVisible = false;

  public motivos = [
    'A conta cadastrada é pessoa jurídica, favor cadastrar conta pessoa física',
    'Cadastrar dados bancários e anexar comprovante de dados bancários',
    'Conferir dados bancários, informações incompletas/divergentes',
    'Dados de telefone incorretos',
  ];

  get urlArquivo(): string {
    return env.VUE_APP_URL_DASHBOARD ?? '';
  }

  get banco(): IDadosBancarios {
    return {
      ...this.indicador.dados_bancarios,
      bancos: this.indicador.bancos,
    };
  }

  get bancoNome(): string {
    return this.indicador?.bancos?.nome ?? '';
  }

  mounted(): void {
    if (Object.keys(this.data ?? []).length === 0) {
      this.updateInfo();
    } else {
      this.updateData();
    }
  }

  @Watch('data')
  updateData(): void {
    this.loadingIndicador = false;
    this.loadingBanco = false;
    this.indicador = this.data;
  }

  @Watch('indicadorId')
  async updateInfo() {
    this.loadingIndicador = true;
    this.loadingBanco = true;
    if ((this.indicadorId ?? 0) !== 0) {
      const response = await Indicador.getByID(this.indicadorId);
      this.indicador = response.data;
    }
    this.loadingIndicador = false;
    this.loadingBanco = false;
  }

  openRejeitar(): void {
    this.popoverRejeitar = !this.popoverRejeitar;
  }

  updateBanco(): void {
    this.loadingBanco = true;
    Indicador.getBanco(this.indicador.id)
      .then((response: GetDadosBancariosResponse) => {
        this.indicador['dados_bancarios'] = response.data as IDadosBancarios;
      })
      .finally(() => {
        this.loadingBanco = false;
      });
  }

  get imagePerfil(): string {
    if (this.indicador.perfil !== undefined && this.indicador.perfil !== '') {
      return this.urlArquivo + this.indicador.perfil;
    }
    return `${this.urlArquivo}/painel/images/perfil/sem-imagem.svg`;
  }

  get bancoTipo(): string {
    let tipo = this.banco?.tipo ?? '';
    if (tipo === 'cc') {
      tipo = 'Corrente';
    } else if (tipo === 'cp') {
      tipo = 'Poupança';
    }
    return tipo;
  }

  get pixTipo(): string {
    let tipo = this.banco?.pix_tipo ?? '';
    if (tipo === 'nao_usar') {
      tipo = 'Não usar';
    } else if (tipo === 'chave_aleatoria') {
      tipo = 'Chave aleatória';
    } else if (tipo === 'cpf_cnpj') {
      tipo = 'CPF/CNPJ';
    } else if (tipo === 'telefone') {
      tipo = 'Telefone';
    } else if (tipo === 'email') {
      tipo = 'Email';
    }
    return tipo;
  }

  get bancoSituacao(): { label: string; icon: string; color: string } {
    const tipo = this.banco?.situacao ?? '';
    switch (tipo) {
      case 'pendente':
        return {
          label: 'Pendente',
          icon: 'mdi-credit-card-clock',
          color: 'text-warning',
        };
      case 'verificado':
        return {
          label: 'Validado',
          icon: 'mdi-credit-card ',
          color: 'text-success',
        };
      case 'rejeitado':
        return {
          label: 'Rejeitado',
          icon: 'mdi-credit-card-off',
          color: 'text-danger',
        };
      default:
        return {
          label: 'Não Informado',
          icon: 'mdi-credit-card-off',
          color: 'text-secundary',
        };
    }
  }

  get bancoSituacaoLabel(): string {
    return this.bancoSituacao.label;
  }
  get bancoSituacaoIcon(): string {
    return this.bancoSituacao.icon;
  }
  get bancoSituacaoColor(): string {
    return this.bancoSituacao.color;
  }

  get bancoDisabled(): boolean {
    return this.banco?.id === undefined;
  }

  get cartoes(): string[] {
    const foto = this.banco.foto_cartao;
    if (foto != undefined && foto !== '') {
      return [this.urlArquivo + foto];
    }
    return [];
  }

  get cartoesDisabled(): boolean {
    return this.cartoes.length === 0;
  }

  setBancoSituacao(situacao: string): void {
    this.loadingBanco = true;
    this.popoverRejeitar = false;
    const data: PatchIndicadorRequest = {
      id: this.banco.id,
      situacao: situacao,
      motivo: this.motivoRejeicao,
    };
    Indicador.patchBanco(this.indicador.id, data).then(() => {
      this.updateBanco();
    });
  }

  dismiss(): void {
    this.$root.$emit('bv::hide::popover');
  }

  setValidacaoSituacao(situacao: string): void {
    this.loadingValidacao = true;
    const data: PatchValidacaoTelefoneRequest = {
      situacao: situacao,
    };
    Indicador.patchValidacaoTelefone(this.indicador.id, data).then(() => {
      this.loadingValidacao = false;
      this.indicador.telefone_validado = situacao;
    });
  }
}
